import type { FC } from 'react';
import { createElement } from 'react';

import { usePostHogFeatureFlag } from '../hooks/usePostHogFeatureFlag';
import ErrorType from '../models/Error';
import ErrorPage from './error/ErrorPage';

type Props = {
  flag: string;
  component: FC;
};

/**
 * Renders `component` only when its PostHog feature flag is enabled; otherwise renders the standard
 * not-found page. Lets a route be gated on an (async) PostHog flag declaratively via
 * `RouteWithTitle.postHogFlag` — the flag's evaluation context is the single source of truth for
 * which environments it's on in. `undefined` (flags still loading) is treated as off; PostHog caches
 * flags after the first load, so the not-found -> content swap only happens on a very first visit.
 */
const PostHogFlagGate: FC<Props> = ({ flag, component }) => {
  const enabled = usePostHogFeatureFlag(flag);

  if (!enabled) {
    return <ErrorPage type={ErrorType.NOT_FOUND} showGoBack showContactSupport />;
  }

  return createElement(component);
};

export default PostHogFlagGate;
